import { Link } from "react-router-dom";

const S = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="font-heading text-lg text-gold-300">{title}</h2>
    <div className="text-white/70 font-light text-sm leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <div className="min-h-screen bg-navy-950 text-white" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto px-6 py-16 space-y-10">
        <div>
          <Link to="/" className="font-mono uppercase tracking-[0.2em] text-[0.6rem] text-gold-400 hover:text-gold-300">← managingdisaster.com.au</Link>
          <h1 className="font-heading font-light text-4xl mt-4">Privacy Policy</h1>
          <p className="text-white/45 font-light text-sm mt-2">FieldClaim by MDAu &amp; The MDAu Office · Managing Disaster Australia (CBKM.au) · Last updated 5 July 2026</p>
        </div>

        <S title="Who we are">
          <p>Managing Disaster Australia (operating under CBKM.au, "we", "us") provides The MDAu Office web platform and the FieldClaim by MDAu mobile application — disaster-recovery claim evidence and management software used by Australian councils and their contractors. Contact: hello@cbkm.au.</p>
        </S>

        <S title="What we collect">
          <p><b>Account information</b> — your name, work email address, role and organisation, provided when your administrator invites you.</p>
          <p><b>Evidence you capture</b> — photos of disaster damage, asset descriptions, measurements, notes and crew hours you record in the app. Photos are GPS-tagged and timestamped at the moment of capture; this precise location data is core to the product — it is what makes claim evidence audit-defensible.</p>
          <p><b>Photos from your library</b> — only those you explicitly attach as evidence.</p>
          <p><b>Technical data</b> — authentication tokens and basic request logs needed to operate and secure the service.</p>
          <p>We do <b>not</b> collect advertising identifiers, we do not track you across other apps or websites, and we do not sell any data.</p>
        </S>

        <S title="How we use it">
          <p>Solely to deliver the service: compiling disaster-recovery claims (DRFA and related programs), evidencing works with location-verified photos, program reporting for your organisation, and account administration. AI features (such as damage-photo classification) process your content to produce claim outputs for your organisation — your content is not used to train third-party models.</p>
        </S>

        <S title="Device permissions">
          <p><b>Camera</b> — to capture damage evidence photos. <b>Location</b> — to GPS-stamp each photo and asset while you use the app. <b>Photo library</b> — to attach existing photos as evidence. Each permission is requested in context and can be declined; related features simply won't function.</p>
        </S>

        <S title="Storage, security and sharing">
          <p>Data is stored encrypted in transit (TLS) and held in our production database. Access is role-based; field devices structurally cannot access commercial data. Your data is shared only with your own organisation's authorised users and, at your organisation's direction, with government funding agencies as part of a claim lodgement (e.g. NSWRA, QRA). We use trusted processors (cloud hosting, and Google APIs only if your administrator connects Google Drive/Gmail). We never sell or rent personal information.</p>
        </S>

        <S title="Retention and deletion">
          <p>Claim evidence is retained for your organisation for the audit life of the disaster program it supports. You may request deletion of your account and personal data at any time by emailing hello@cbkm.au; we will action requests within 30 days, subject to legal record-keeping obligations attached to lodged claims.</p>
        </S>

        <S title="Your rights">
          <p>We handle personal information in accordance with the Australian Privacy Principles (Privacy Act 1988). You can request access to, correction of, or deletion of your personal information at hello@cbkm.au. If you are unsatisfied with our response you may complain to the OAIC (oaic.gov.au).</p>
        </S>

        <S title="Children">
          <p>The service is a workplace tool for adult council staff and contractors and is not directed at children under 16.</p>
        </S>

        <S title="Changes">
          <p>We will post any changes to this policy on this page and update the date above. Material changes will be notified in-app.</p>
        </S>
      </div>
    </div>
  );
}
